import naturalSort from "javascript-natural-sort";


function TenantOverlaysCtrl($stateParams,
                            TenantsService,
                            $state,
                            ProgressBarService,
                            ToastsService,
                            $scope,
                            ImageService,
                            $timeout,
                            $mdDialog) {
  "ngInject";

  let vm = this;
  $scope.tabIndex = 4;
  vm.tenantId = $stateParams.tenantId;
  vm.editMode = !!$stateParams.tenantId;
  let tenantPromise = TenantsService.getTenantById(vm.tenantId);
  tenantPromise.then(data => {
    vm.currentTenant = data;
  });

  vm.overlayPositions = [
    {
      "name": 'Top-Left',
      "position": "topLeft",
    },
    {
      "name": 'Top-Right',
      "position": "topRight",
    },
    {
      "name": 'Bottom-Left',
      "position": "bottomLeft",
    },
    {
      "name": 'Bottom-Right',
      "position": "bottomRight"
    }
  ];

  vm.overlayChanged = false;

  ////////////////////////////////////////////////////////////////
  // Overlays
  ////////////////////////////////////////////////////////////////
  vm.adjustOverlaysAvailable = (status) => {
    vm.currentTenant.overlaysAvailable = status
    ProgressBarService.start();
    vm.loadingOverlays = true;
    let promise = TenantsService.save(vm.currentTenant);
    promise.then(() => {
      ProgressBarService.complete();
      let tenantPromise = TenantsService.getTenantById($stateParams.tenantId);
      tenantPromise.then(function (tenant) {
        vm.loadingOverlays = false;
        vm.onSuccessResolvingTenant(tenant);
      });
    });
    promise.catch((err) => {
      ProgressBarService.complete();
      ToastsService.showErrorToast('Something went wrong');
      vm.loadingOverlays = false;
    });
    return promise;
  };

  vm.updateOverlays = () => {
    vm.loadingOverlays = true;
    let tenantPromise = vm.getTenant();
    tenantPromise.then((tenant) => {
      vm.overlayChanged = false;
      vm.currentTenant.overlayTemplate = tenant.overlayTemplate;
      vm.currentTenantCopy.overlayTemplate = angular.copy(vm.currentTenant.overlayTemplate);
      vm.loadingOverlays = false;
    });
    return tenantPromise;
  };

  vm.submitOverlaySettings = () => {
    vm.loadingOverlays = true;

    let overlaySettings = angular.copy(vm.currentTenantCopy.overlayTemplate);
    ProgressBarService.start();
    let promise = TenantsService.saveOverlaySettings(
      vm.tenantId,
      overlaySettings.bottomLeft,
      overlaySettings.bottomRight,
      overlaySettings.topRight,
      overlaySettings.topLeft
    );

    let updateOverlayPromiseDeferred = () => {
      let updateOverlayPromise = vm.updateOverlays();
      updateOverlayPromise.then((res) => {
        ToastsService.showSuccessToast('We saved your update.');
        ProgressBarService.complete();
      });
      return updateOverlayPromise;
    };

    promise.then(() => {
      $timeout(updateOverlayPromiseDeferred, 1000);
    });

    promise.catch((res) => {
      ProgressBarService.complete();
      ToastsService.showErrorToast('Something went wrong');
    });
    return promise;
  };

  vm.applyTenantOverlay = (ev) => {
    let confirm = $mdDialog.confirm(
      {
        title: `Are you sure?`,
        textContent: `Each device in your Tenant will have the current Overlay Template applied as its settings.`,
        targetEvent: ev,
        ariaLabel: 'Lucky day',
        ok: 'Confirm',
        cancel: 'Nevermind'
      }
    );

    $mdDialog.show(confirm).then((function () {
      ProgressBarService.start();
      let promise = TenantsService.overlayApplyTenant(vm.tenantId)
      promise.then((res) => {
        let message = 'Your Tenant Overlay Settings are being applied to each device in your Tenant. Please wait patiently for this process to complete.'
        ToastsService.showSuccessToast(message);
        vm.loading = true;
        vm.getTenant();
        ProgressBarService.complete();
      });
      promise.catch((res) => {
        ProgressBarService.complete();
        ToastsService.showErrorToast('Something went wrong');

      });
      return promise;
    }));

  };

  vm.checkForOverlayChanges = () => {
    let changed = false;
    let currentTenantOverlays = vm.currentTenant.overlayTemplate;
    let currentTenantCopyOverlays = angular.copy(vm.currentTenantCopy.overlayTemplate);
    let positions = ['topLeft', 'topRight', 'bottomRight', 'bottomLeft'];
    for (let pos of positions) {
      if (currentTenantOverlays[pos].size !== currentTenantCopyOverlays[pos].size) {
        changed = true;
      }
      if (currentTenantOverlays[pos].type !== currentTenantCopyOverlays[pos].type) {
        if (currentTenantOverlays[pos].type.includes('logo')) {
          if ((currentTenantOverlays[pos].type + ": " + currentTenantOverlays[pos].image.type) !== currentTenantCopyOverlays[pos].type) {
            changed = true;
          }
        }
        else {
          changed = true;
        }
      }
    }
    vm.overlayChanged = changed;
  };


  ////////////////////////////////////////////////////////////////
  // Images
  ////////////////////////////////////////////////////////////////
  vm.submitImage = () => {
    if (vm.selectedLogo && vm.selectedLogo[0]) {
      let formData = new FormData();
      let validFile = true;
      angular.forEach(vm.selectedLogo, function (obj) {
        if (obj.lfFile.size < 15000000) {
          formData.append('files', obj.lfFile);
        } else {
          vm.fileApi.removeAll();
          validFile = false;
          ToastsService.showErrorToast('Your image is larger than 15 MB. Please choose a smaller image');
        }
      });

      if (validFile) {
        let promise = ImageService.saveImage(vm.tenantId, formData);
        promise.then((res) => {
          ProgressBarService.complete();
          $timeout(vm.getTenantImages, 1000);
          vm.fileApi.removeAll();
          ToastsService.showSuccessToast('We uploaded your image.');
        });
        promise.catch((res) => {
          ProgressBarService.complete();
          ToastsService.showErrorToast('Something went wrong. You may have already uploaded this image.');
        });
        return promise;
      }
    }
  };

  vm.getTenantImagesAndReloadTenantAfterDelete = () => {
    let tenantImagePromise = vm.getTenantImages();
    tenantImagePromise.then(() => {
      let updateOverlayPromise = vm.updateOverlays();
      updateOverlayPromise.then(() => {
        ToastsService.showSuccessToast('We deleted your image.');
        ProgressBarService.complete();
      })
    })
  };

  vm.deleteImage = (ev, name, key) => {
    let confirm = $mdDialog.confirm(
      {
        title: `Are you sure?`,
        textContent: `If you proceed, ${name} will be deleted and removed from all devices that use it.`,
        targetEvent: ev,
        ariaLabel: 'Lucky day',
        ok: 'Confirm',
        cancel: 'Nevermind'
      }
    );

    $mdDialog.show(confirm).then((function () {
      ProgressBarService.start();
      let promise = ImageService.deleteImage(key);
      promise.then((res) => {
        $timeout(vm.getTenantImagesAndReloadTenantAfterDelete, 1000);
      });
      promise.catch((res) => {
        ToastsService.showErrorToast('Something went wrong while deleting your image.');
        ProgressBarService.complete();
      });
      return promise;
    }))
  };

  vm.getTenantImages = () => {
    vm.OVERLAY_TYPES = [
      {size: null, type: "none", imageId: null},
      {size: null, type: "datetime", imageId: null},
    ];

    ProgressBarService.start();
    let promise = ImageService.getImages(vm.tenantId);
    promise.then((res) => {
      vm.tenantImages = res;
      ProgressBarService.complete();
      for (let value of vm.tenantImages) {
        for (let sizeOption of ["small", "large"]) {
          let newValue = {
            name: value.name,
            type: "logo",
            size: sizeOption,
            imageId: value.id
          };
          vm.OVERLAY_TYPES.push(newValue);
        }
      }
      vm.OVERLAY_TYPES.sort(naturalSort);
    });

    promise.catch(() => {
      ProgressBarService.complete();
      ToastsService.showErrorToast("Something went wrong when retrieving your images.")
    });

    return promise
  };

  //////////////////////////////////////////////////////////////
  // Setup
  //////////////////////////////////////////////////////////////
  vm.onSuccessResolvingTenant = function (tenant) {
    vm.currentTenant = tenant;
    if (vm.currentTenant.overlaysAvailable) {
      for (let each of ["bottomRight", "topRight", "topLeft", "bottomLeft"]) {
        if (vm.currentTenant.overlayTemplate[each].type == null) {
          vm.currentTenant.overlayTemplate[each].type = "none";
        }
      }
    }
    vm.currentTenantCopy = angular.copy(vm.currentTenant);
    vm.selectedTimezone = tenant.default_timezone;

  };

  vm.getTenant = () => {
    vm.loadingOverlays = true;
    let tenantPromise = TenantsService.getTenantById($stateParams.tenantId);
    tenantPromise.then(function (tenant) {
      vm.currentTenant = tenant;
      if (vm.currentTenant.overlaysAvailable) {
        for (let each of ["bottomRight", "topRight", "topLeft", "bottomLeft"]) {
          if (vm.currentTenant.overlayTemplate[each].type == null) {
            vm.currentTenant.overlayTemplate[each].type = "none";
          }
        }
      }

      if (vm.currentTenant.overlaysUpdateInProgress) {
        vm.loading = true;
        $timeout(vm.getTenant, 3000);
      } else {
        vm.loading = false;
      }
      vm.loadingOverlays = false;
      vm.currentTenantCopy = angular.copy(vm.currentTenant);
    });
    return tenantPromise
  };

  vm.initialize = () => {
    vm.getTenantImages();
    vm.getTenant()
  };

  $scope.$watch('tabIndex', function (toTab, fromTab) {
    if (toTab !== undefined) {
      switch (toTab) {
        case 0:
          return $state.go('main.tenantDetails', {tenantId: $stateParams.tenantId});
        case 1:
          return $state.go('main.tenantManagedDevices', {tenantId: $stateParams.tenantId});
        case 2:
          return $state.go('main.tenantUnmanagedDevices', {tenantId: $stateParams.tenantId});
        case 3:
          return $state.go('main.tenantLocations', {tenantId: $stateParams.tenantId});
        case 4:
          return $state.go('main.tenantOverlays', {tenantId: $stateParams.tenantId});
        case 5:
          return $state.go('main.tenantLogs', {tenantId: $stateParams.tenantId});
        case 6:
          return $state.go('main.tenantProofPlay', {tenantId: $stateParams.tenantId});
      }
    }
  });

  return vm;
}

export {TenantOverlaysCtrl}
